import { FC } from "react";
import { ProviderConnectionsPageWrapper } from "@/components/pages/integrations/components/provider-connections/common/components/ProviderConnectionsPageWrapper";
import { SnowflakeConnectionGrid } from "@/components/pages/integrations/components/provider-connections/snowflake/components/grid/SnowflakeConnectionGrid";

export const SnowflakeConnection: FC = () => {
  return (
    <ProviderConnectionsPageWrapper type="snowflake" breadcrumbs={breadcrumbs}>
      <SnowflakeConnectionGrid />
    </ProviderConnectionsPageWrapper>
  );
};

const breadcrumbs = [
  { title: "Integrations", to: "/integrations" },
  { title: "Snowflake" },
];
